import { Action, createReducer, on } from '@ngrx/store';
import { PolicyRoutingStatistics } from '../policy-routing-statistics.model';
import {
  clearPolicyRoutingStatisticsAction,
  setPolicyRoutingStatisticsAction,
} from './policy-routing-statistics.action';

const initialState: PolicyRoutingStatistics[] = [];

const reducer = createReducer(
  initialState,
  on(setPolicyRoutingStatisticsAction, (_, props) => props.policy_routing_statistics),
  on(clearPolicyRoutingStatisticsAction, () => initialState)
);

export function policyRoutingStatisticsReducer(
  state: PolicyRoutingStatistics[] | undefined,
  action: Action
) {
  return reducer(state, action);
}
